import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "td__use-yn" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "td__type" };
const _hoisted_5 = { class: "td__work-time" };
const _hoisted_6 = { class: "td__phone" };
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "td__employee-type ta-c" };
const _hoisted_11 = { class: "td__salary-type ta-c" };
const _hoisted_12 = { class: "td__total-insurance-deposit-baromoney" };
const _hoisted_13 = { class: "td__deposit-baromoney" };
const _hoisted_14 = { class: "td__baromoney" };
const _hoisted_15 = { class: "ta-c" };
const _hoisted_16 = { class: "td__worker-reg-date ta-c" };
import employeeTypeCode from '@/constants/employeeTypeCode';
import { timeZoneCode } from '@/constants/global';
import { routeName } from '@/constants/routeName';
import { salaryTypeData, typeData, } from '@/constants/workerManagementList';
import { currency, injectSeparatorDateString, injectSeparatorTimeString, validateTextWithHypen, changeStartEndStringTimeZone, } from '@/utils';
import { formatPhoneNumber } from '@/utils/regularExpression';
import vuexStore from '@/vuex-store';
import { computed, toRefs } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: { default: () => ({}) }
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const { item, } = toRefs(props);
        const getterWorkerStatusValue = computed(() => vuexStore.getters['workerManagement/workerList/getterWorkerStatusValue']);
        const getterSearchField = computed(() => vuexStore.getters['workerManagement/workerList/getterSearchField']);
        const getterSearchValue = computed(() => vuexStore.getters['workerManagement/workerList/getterSearchValue']);
        const getterPageSizeType = computed(() => vuexStore.getters['workerManagement/workerList/getterPageSizeType']);
        // 상태
        const useYn = computed(() => {
            const useYnState = item.value.useYn.toLowerCase();
            const fileName = `/svg/use-yn-${useYnState}.svg`;
            return fileName;
        });
        // 라이더 유형
        const type = computed(() => typeData[item.value.type].text);
        // 운행 상태
        const workerAttend = computed(() => item.value.workerAttendCode);
        // 근무 시간
        const workTime = computed(() => {
            const krTimeString = changeStartEndStringTimeZone(item.value.workTime, timeZoneCode.KR);
            return injectSeparatorTimeString(krTimeString);
        });
        // 단말기 번호
        const phone = computed(() => formatPhoneNumber(item.value.phone));
        // 차량 번호
        const carNumber = computed(() => validateTextWithHypen(item.value.carNumber));
        // 사번
        const hubEmployeeNumber = computed(() => validateTextWithHypen(item.value.hubEmployeeNumber));
        // 고용 형태
        const employeeTypeText = computed(() => employeeTypeCode[item.value.employeeType].text);
        // 보수 지급방식
        const salaryType = computed(() => salaryTypeData[item.value.salaryType].text);
        // 보유 바로머니
        const baromoneyWithCurrency = computed(() => currency(item.value.baromoney));
        // 입사일
        const workerRegData = computed(() => injectSeparatorDateString(item.value.workerRegDate));
        const handleClickWorker = (worker) => {
            const { code } = worker;
            router.push({
                name: routeName.WORKER_MANAGEMENT_WORKER_DETAIL,
                params: {
                    code,
                },
                query: {
                    searchField: getterSearchField.value,
                    searchValue: getterSearchValue.value,
                    workerStatus: getterWorkerStatusValue.value,
                    pageSizeType: getterPageSizeType.value,
                },
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createCommentVNode(" 상태 "),
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("img", { src: useYn.value }, null, 8 /* PROPS */, _hoisted_2)
                ]),
                _createCommentVNode(" 라이더명 "),
                _createElementVNode("td", {
                    class: "td__worker-name",
                    title: _unref(item).name,
                    onClick: _cache[0] || (_cache[0] = ($event) => (handleClickWorker(_unref(item))))
                }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(item).name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_3),
                _createCommentVNode(" 유형 "),
                _createElementVNode("td", _hoisted_4, _toDisplayString(type.value), 1 /* TEXT */),
                _createCommentVNode(" 운행상태 "),
                _createElementVNode("td", {
                    class: _normalizeClass(["td__attend-code", workerAttend.value.textColorClass])
                }, _toDisplayString(_ctx.$t(workerAttend.value.text)), 3 /* TEXT, CLASS */),
                _createCommentVNode(" 근무시간 "),
                _createElementVNode("td", _hoisted_5, _toDisplayString(workTime.value), 1 /* TEXT */),
                _createCommentVNode(" 전화번호 = 단말기번호 "),
                _createElementVNode("td", _hoisted_6, _toDisplayString(phone.value), 1 /* TEXT */),
                _createCommentVNode(" 차량번호 "),
                _createElementVNode("td", {
                    class: "td__car-number",
                    title: carNumber.value
                }, _toDisplayString(carNumber.value), 9 /* TEXT, PROPS */, _hoisted_7),
                _createCommentVNode(" 소속허브명 "),
                _createElementVNode("td", {
                    class: "td__hub-name",
                    title: _unref(item).hubName
                }, _toDisplayString(_unref(item).hubName), 9 /* TEXT, PROPS */, _hoisted_8),
                _createCommentVNode(" 사번 "),
                _createElementVNode("td", {
                    class: "td__hub-employee-number ta-c",
                    title: hubEmployeeNumber.value
                }, _toDisplayString(hubEmployeeNumber.value), 9 /* TEXT, PROPS */, _hoisted_9),
                _createCommentVNode(" 고용형태 "),
                _createElementVNode("td", _hoisted_10, _toDisplayString(employeeTypeText.value), 1 /* TEXT */),
                _createCommentVNode(" 보수지급방식 "),
                _createElementVNode("td", _hoisted_11, _toDisplayString(salaryType.value), 1 /* TEXT */),
                _createCommentVNode(" 고용/산재보험예치금 "),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(item).formattedTotalInsuranceDepositBaromoney), 1 /* TEXT */),
                _createCommentVNode(" 허브설정예치금 "),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(item).formattedDepositBaromoney), 1 /* TEXT */),
                _createCommentVNode(" 바로머니잔액 "),
                _createElementVNode("td", _hoisted_14, _toDisplayString(baromoneyWithCurrency.value), 1 /* TEXT */),
                _createCommentVNode(" 결격여부 "),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(item).convictionStatusForUser), 1 /* TEXT */),
                _createCommentVNode(" 입사일 "),
                _createElementVNode("td", _hoisted_16, _toDisplayString(workerRegData.value), 1 /* TEXT */)
            ]));
        };
    }
});
